import apiClient from "../common/apiClient";

export default class ErrorLogsController {
  async HandleException(data) {
    try {
      return await apiClient.post("/errorLogger", JSON.stringify(data));
    } catch (error) {
      return error;
    }
  }
}
